export * from '@fhs/routing/src/routes/(tabs)/(more)/account/other-terms';
export { default } from '@fhs/routing/src/routes/(tabs)/(more)/account/other-terms';
